// extracted by mini-css-extract-plugin
export default {"deleteSection":"DeleteStyle_deleteSection__LT-Mw","deleteSectionBtn":"DeleteStyle_deleteSectionBtn__zTPNe"};